import { css } from '@emotion/react';
import { theme } from 'global';

export const main = css`
  display: flex;
  justify-content: center;
  height: calc(100vh - var(--header-height));
  background-color: ${theme.colors.neutral[0]};
  padding: 40px 0;

  @media screen and (max-width: ${theme.breaks.xs}px) {
    background-color: ${theme.colors.white};
  }
`;

export const container = css`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  max-width: 552px;
  max-height: 340px;
  padding: 24px;
  border-radius: 8px;
  background-color: ${theme.colors.white};

  @media screen and (max-width: ${theme.breaks.xs}px) {
    padding: 16px;
  }
`;

export const text = css`
  margin-top: 24px;
`;

export const loginButton = css`
  padding: 14px 24px !important;
  color: ${theme.colors.primary.medium};
  border: 1px solid ${theme.colors.primary.medium};
  border-color: ${theme.colors.primary.medium};
`;

export const homeButton = css`
  margin-bottom: 20px;
  padding: 14px 24px;
`;

export const buttonsGroup = css`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 24px;
`;
